// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown:hover .dropdown-menu[data-v-1e2b4bc6]{display:block}", ""]);
// Exports
module.exports = exports;
